import { render, staticRenderFns } from "./_add-item.vue?vue&type=template&id=9f7d8040&"
import script from "./_add-item.vue?vue&type=script&lang=js&"
export * from "./_add-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports